module.exports = __webpack_public_path__ + "static/media/category_count.cc121e18.png";